import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { IframeService } from '@core/services/iframe.service';

const ALLOWED_PATTERNS = [/^\/assessments\/new$/, /^\/assessments\/detail\/.+$/];

export const iframeGuard: CanActivateChildFn = (_route, state) => {
  const iframeService = inject(IframeService);
  const router = inject(Router);

  if (!iframeService.isEmbedded) {
    return true;
  }

  const path = state.url.split('?')[0];
  if (ALLOWED_PATTERNS.some(pattern => pattern.test(path))) {
    return true;
  }

  return router.createUrlTree(['/assessments/new']);
};
